import React from 'react';
import { Divider, Segment, Image, Header } from 'semantic-ui-react';
import { arrayOf, shape, string } from 'prop-types';

const ComingSoon = ({ nextEpisode, terms }) => {
  const localeString = nextEpisode.languageId === 2 ? 'es' : 'en';
  const date = new Date(
    new Date(nextEpisode.meta).getTime() + 5 * 60 * 60 * 1000
  ).toLocaleString(localeString, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
  return (
    <React.Fragment>
      <Divider horizontal inverted>
        {terms[0]}
      </Divider>
      <Segment
        id="next-epsiode"
        raised={false}
        inverted
        style={{ width: '100%', margin: '.5em' }}
      >
        <Image floated="left" size="tiny" src={nextEpisode.image} />
        <Header style={{ marginTop: '0em', marginBottom: '.25em' }}>
          {terms[2]}
        </Header>
        <p id="next-episode-description">
          {`${nextEpisode.header} ${terms[5]} ${date}.`}
        </p>
      </Segment>
    </React.Fragment>
  );
};

ComingSoon.propTypes = {
  nextEpisode: shape().isRequired,
  terms: arrayOf(string).isRequired,
};

export default ComingSoon;



// WEBPACK FOOTER //
// ./src/components/Feed/ComingSoon.jsx